import state from './state'

const initialState = JSON.parse(JSON.stringify(state))

export const SET_CONFIG = (state, { config, org }) => {
  state.config = config
  state.org = org
}

export const SET_ORG_LOGO = (state, logo) => {
  state.orgLogo = logo
}

export const SET_ORG_LOGO_MOBILE = (state, logo) => {
  state.orgLogoMobile = logo
}

export const SET_BG_IMG = (state, img) => {
  state.backgroundImg = img
}

export const SET_KML_FILE = (state, file) => {
  state.kmlFile = file
}

export const SET_REGISTRATION_FIELDS = (state, registrationFields) => {
  state.registrationFields = registrationFields
}

export const RESET = (state) => {
  Object.keys(initialState).forEach(key => {
    state[key] = initialState[key]
  })
}

